import React from "react"
import styled from "styled-components"
import Role from "./Role"
import CoolBox from "./CoolBox"

export default function ABlock({
  img,
  name,
  chance,
  investment,
  saying,
  peopleName
}) {
  return (
    <Wrapper>
      <TopWrapper>
        <TitlesWrapper>
          <TitleWrapper className="title">
            {peopleName ? peopleName : "你"}的代表人物是
          </TitleWrapper>
          <TitleResultWrapper>
            <p>1</p>
            <TitleResult className="titleResult">{name}</TitleResult>
          </TitleResultWrapper>
        </TitlesWrapper>
        <RoleWrapper className="RoleWrapper">
          <Role img={img} />
        </RoleWrapper>
      </TopWrapper>
      <BottomWrapper>
        <SayingWrapper className="SayingWrapper">{saying}</SayingWrapper>
        <CoolBox chance={chance} investment={investment} />
      </BottomWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
`
const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 12px;
  margin-top: 30px;
  @media (max-width: 1200px) {
    flex-direction: row;
    justify-content: center;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 0px;
  }
`
const TitlesWrapper = styled.span`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  align-items: start;
`

const TitleWrapper = styled.span`
  font-size: 36px;
  font-weight: 700;
  color: #000;
  background-color: #00fff0;
  padding: 4px 12px;
  z-index: 2;
  white-space: nowrap;
  display: inline-block;
  @media (max-width: 1200px) {
    font-size: 36px;
  }
  @media (max-width: 768px) {
    font-size: 24px;
  }
`
const TitleResultWrapper = styled.div`
  position: relative;
  font-size: 48px;
  font-weight: 700;
  p {
    color: rgba(0, 0, 0, 0);
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`
const TitleResult = styled.div`
  font-size: 48px;
  font-weight: 700;
  color: #000;
  background-color: #00fff0;
  padding: 4px 12px;
  position: absolute;
  top: 0;
  left: 100px;
  white-space: nowrap;
  z-index: 2;
  @media (max-width: 1200px) {
    font-size: 36px;
    left: 5vw;
  }
  @media (max-width: 768px) {
    left: 0px;
    font-size: 32px;
    white-space: pre-wrap;
  }
  @media (max-width: 500px) {
    font-size: 24px;
  }
`
const RoleWrapper = styled.div`
  display: none;
  width: 100%;
  @media (max-width: 1200px) {
    display: flex;
    max-width: 700px;
    scale: 1.2;
    z-index: 0s;
  }
  @media (max-width: 768px) {
    max-width: 500px;
    scale: 1.3;
    margin: -30px auto 40px;
  }
`
const SayingWrapper = styled.div`
  font-size: 18px;
  color: #00fff0;
  font-weight: 700;
  text-shadow: 2px 1px 10px #04ebcd;
  margin-bottom: 40px;
  position: relative;
  display: inline-block;
  padding: 8px 8px;
  /* border: 1px solid #00fff0; */
  &:before {
    content: "「";
    position: absolute;
    font-size: 36px;
    top: -12px;
    left: -20px;
    width: 30px;
    height: 30px;
  }
  &:after {
    content: "」";
    position: absolute;
    font-size: 36px;
    bottom: 10px;
    right: -16px;
    width: 30px;
    height: 30px;
  }
`
const BottomWrapper = styled.div`
  position: relative;
`
